import styled from 'styled-components';
import { font, CheckmarkIcon, spacing } from '@chegg-ui/theme';
import { SecondaryButton } from '@chegg-ui/button';
var family = font.family,
  size = font.size,
  weight = font.weight;
var px14 = size.px14,
  px16 = size.px16;
export var CouponContainer = styled.div.withConfig({
  componentId: "sc-1nnwcg5-0"
})(["font-family:", ";"], family.aspira);
export var FormWrapper = styled.div.withConfig({
  componentId: "sc-1nnwcg5-1"
})(["display:flex;flex-direction:row;align-items:center;"]);
export var TextFieldWrapper = styled.div.withConfig({
  componentId: "sc-1nnwcg5-2"
})(["display:inline-block;position:relative;width:220px;margin-bottom:", ";.sr-coupon-message{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;}"], function (_ref) {
  var error = _ref.error;
  return error ? '15px' : 0;
});
export var StyledCheckmarkIcon = styled(CheckmarkIcon).withConfig({
  componentId: "sc-1nnwcg5-3"
})(["z-index:2;position:absolute;right:5px;top:33px;"]);
export var StyledSecondaryButton = styled(SecondaryButton).withConfig({
  componentId: "sc-1nnwcg5-4"
})(["font-size:", ";padding:0;font-weight:", ";"], px14, weight.medium);
export var StyledTermsButton = styled(StyledSecondaryButton).withConfig({
  componentId: "sc-1nnwcg5-5"
})(["margin-top:", ";"], spacing.px12);
export var StyledTerms = styled.div.withConfig({
  componentId: "sc-1nnwcg5-6"
})(["padding:", ";padding-bottom:", ";text-align:center;"], spacing.px64, spacing.px32);
export var StyledCouponButton = styled(SecondaryButton).withConfig({
  componentId: "sc-1nnwcg5-7"
})(["padding:8px;margin-left:2px;font-size:", ";:active{outline:none;}"], px16);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/Coupon/views/App/styled.js
// module id = 3506
// module chunks = 11